import React, { useState } from 'react'
import employeeIcon from '../../../assets/user-img.svg'
import { t } from 'i18next';
import { parseMillisecondsToHoursAndMinutes } from '../../../helpers/helpers';
import PermanenceTableDetail from './PermanenceTableDetail/PermanenceTableDetail';

const PermanenceTableList = ({ report }) => {

    const [showMore, setShowMore] = useState(false);

    return (
        <>
            <tr /*style={{cursor:'pointer'}}*/>
                <td className='custom-border'>
                    <div className='d-flex gap-2 align-items-center'>
                        <img
                            src={employeeIcon}
                            alt=""
                            style={{ width: '24px', height: '24px' }}
                        />
                        <div>
                            <span className='d-block blue-text'>
                                {report.employee_name}
                            </span>
                            <span className='d-block text-description'>
                                {report.employee_natural_id}
                            </span>
                        </div>

                    </div>
                </td>
                <td className='custom-border blue-dark-text text-center'>
                    {report.contract_type_employee}
                </td>
                <td className='custom-border'>
                    <span className='d-block blue-dark-text'>
                        {report.contractor_name}
                    </span>
                    <span className='d-block text-description'>
                        {report.contractor_natural_id}
                    </span>
                </td>
                <td className='custom-border blue-dark-text-two text-center'>
                    {report.total_records} {t('RECORDS')}
                </td>
                <td className='custom-border blue-dark-text-two text-center'>
                    {report.total_hs_normal ? (<strong>{Number(parseMillisecondsToHoursAndMinutes(report.total_hs_normal).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(report.total_hs_normal).split(':')[1])}min</strong>) : '-'}
                </td>
                <td className='custom-border blue-dark-text-two text-center'>
                    {report.total_hs_50 ? (<strong>{Number(parseMillisecondsToHoursAndMinutes(report.total_hs_50).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(report.total_hs_50).split(':')[1])}min</strong>) : '-'}
                </td>
                <td className='blue-dark-text-two text-center'>
                    {report.total_hs_100 ? (<strong>{Number(parseMillisecondsToHoursAndMinutes(report.total_hs_100).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(report.total_hs_100).split(':')[1])}min</strong>) : '-'}
                </td>
                <td className='text-center'>
                    <i
                        type='button'
                        className={`fa-solid fa-chevron-${showMore ? 'up' : 'down'}`}
                        onClick={() => setShowMore(!showMore)}
                    >
                    </i>
                </td>
            </tr>
            {showMore && (
                <tr>
                    <td
                        colSpan={8}
                        style={{ background: '#F8FCFF' }}
                    >
                        <PermanenceTableDetail reportDetail={report.accessEmp} />
                    </td>
                </tr>
            )}
        </>
    )
}

export default PermanenceTableList